import * as React from 'react';
import * as _ from 'underscore';

import { ServiceLocator } from '../../ServiceLocator';
import { VizUrl } from '../VizSpace/VizUrlHelpers';

export const RemoveTrailingSlashWrapper: React.FunctionComponent<{}> = props => {
  const $location = ServiceLocator.get<ng.ILocationService>('$location');
  const path = $location.path();
  if (!VizUrl.isCurrentUrlViz() && path.endsWith('/')) {
    $location.path(path.substring(0, path.length-1));
  }

  return <>{props.children}</>;
};
